import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import moment from 'moment';

import { Logo, MCButton, MCText, Steps, View } from 'src/components/basic';
import HomeLeft from 'src/components/HomeLeft';
import SVGIcon, { BASE_ICONS, GENERAL_ICONS } from 'src/components/svg';

import {
  scssVariables as variables,
  lang,
  useLanguage,
  useScreenDetail,
  remCss
} from 'src/helpers';
import LangSelect from './LangSelect';

export const StepAuthContainer = ({ steps = [], children, pathname, stepLeft = null }) => {
  const activeStep = steps.find((s) => s.name === pathname);
  let screenDetail = useScreenDetail();
  if (screenDetail.isSmallScreen) {
    return (
      <AuthContainer enableHomeLeft={false} enableFooter={false}>
        <div className={'mc-page-auth-box'}>
          <div className={'mc-box-header-bar'} />
          {!!steps?.length && <Steps list={steps} current={pathname} screenDetail={screenDetail} />}
          {stepLeft}
          {children}
        </div>
      </AuthContainer>
    );
  }
  return (
    <AuthContainer enableWrap={false} enableHomeLeft={false} enableFooter={false}>
      <div className={'mc-signup-steps'}>
        {!!steps?.length && <Steps list={steps} current={pathname} screenDetail={screenDetail} />}
        {stepLeft}
        <div className={'mc-signup-step'}>
          {activeStep && (
            <div className={'mc-flex-10-col'}>
              <div className='mc-value-936'>{lang.t(activeStep.title)}</div>
              <div className='mc-value-418'>{lang.t(activeStep.description)}</div>
            </div>
          )}
          {children}
        </div>
      </div>
    </AuthContainer>
  );
};

export const AuthHeader = ({ headerBtn, drawMenu }) => {
  const screen = useScreenDetail();
  const [isOpen, setOpen] = useState(false);
  const isStickyVersion = true;

  return (
    <>
      <View
        style={{
          zIndex: 2,
          alignItems: 'flex-start',
          padding: remCss(screen.isLargeScreen ? 30 : 20),
          flexDirection: 'row',
          ...(screen.isSmallScreen && drawMenu && (isStickyVersion || isOpen)
            ? {
                backgroundColor: 'white',
                borderBottom: `1px solid ${variables['colors-mc-border']}`,
                position: 'sticky',
                top: 0
              }
            : {})
        }}
      >
        <Link to={'/'}>
          <Logo screenDetail={screen} />
        </Link>
        {!drawMenu &&
          (headerBtn || (
            <>
              <View style={{ flex: 1 }} />
              <LangSelect width={remCss(200)} />
            </>
          ))}
        {!!drawMenu && (
          <div
            className={`mc-dropdown-menu ${isOpen ? 'open' : ''}`}
            style={{ marginLeft: 'auto' }}
          >
            <MCButton
              className={'mc-dropdown-menu-icon'}
              tiny
              onClick={(e) => {
                e.preventDefault();
                setOpen(!isOpen);
              }}
              transparent
            >
              <SVGIcon
                width={48}
                iconname={BASE_ICONS.HAMBURG}
                fill={isStickyVersion ? variables['colors-mc-primary'] : undefined}
              />
            </MCButton>
            <View style={{ position: 'absolute', top: remCss(120), right: remCss(30) }}>
              <LangSelect width={remCss(200)} />
            </View>
            <View
              className={'mc-dropdown-menu-list'}
              style={{ padding: remCss(38), gap: remCss(38) }}
            >
              {drawMenu?.map(({ label, icon, ...item }, index) => (
                <View
                  key={index}
                  style={{
                    flexDirection: 'row'
                  }}
                >
                  <MCButton {...item} tiny style={{ gap: 'space-between' }}>
                    {icon}
                    <MCText label={label} size={22} weight={500} textLight lineHeight={21} />
                  </MCButton>
                </View>
              ))}
            </View>
          </div>
        )}
      </View>
      <div className={'mc-page-auth-image-right'}>
        <SVGIcon iconname={GENERAL_ICONS.LOGO_RIGHT} />
      </div>
    </>
  );
};

const AuthContainer = ({
  children,
  enableFooter = true,
  enableWrap = true,
  enableHomeLeft = true,
  style: styleProp = {}
}) => {
  let language = useLanguage();

  const footer = (
    <div className={'mc-page-auth-footer'} key={language}>
      © {moment().format('YYYY')}. {lang.t('All rights reserved.')}
    </div>
  );

  const style = { ...styleProp };
  style.backgroundColor = variables['colors-mc-white'];
  // if (screenDetail.isSmallScreen) {
  //   style.marginTop = remCss(91);
  // }
  return (
    <>
      <View
        style={{
          width: '100%',
          zIndex: 3,
          top: 0,
          left: 0,
          right: 0,
          position: 'fixed'
        }}
      >
        <AuthHeader />
      </View>
      <div className={'mc-page-auth'} style={style}>
        <View style={{ marginTop: remCss(91) }} />
        {enableHomeLeft && <HomeLeft />}
        <div className={'mc-page-auth-content'}>
          {enableWrap ? (
            <div className={'mc-page-auth-wrap'}>
              {children}
              {enableFooter && footer}
            </div>
          ) : (
            <>
              {children}
              {enableFooter && footer}
            </>
          )}
        </div>
      </div>
    </>
  );
};
export default AuthContainer;
